<div class="loading-indicator-wrapper" *ngIf="loading && !inItemEditorModal">
  <fts-loading-indicator></fts-loading-indicator>
</div>
<fts-editor *ngIf="orderableItem && item"
  [imageSrc]="orderableItem?.getImage()?.src"
  [orderableItem]="orderableItem"
  [orderedItem]="item"
  [upsellItems]="upsellItems"
  [theme]="theme"
  [storeConfig]="storeConfig"
  [inItemEditorModal]="inItemEditorModal"
  (triggerUpsellsOnSizeChange)="onChangeSizeTriggerUpsells($event)">
</fts-editor>
